import store from '@/store';
import normalizeNameWithOptions from './normalizeNameWithOptions';

/**
 * Normalizes name fields using the baseline sanitizer.
 * @param {string} input - Raw name input from the form.
 * @returns {string} Sanitized name value.
 */
export default function normalizeName(input) {
  const { features } = store.getState().whitelabelConfig;

  return normalizeNameWithOptions(input, {
    removeAccents: !features.SUPPORT_FOR_ORTHOGRAPHIC_ACCENTS_ON_PASSENGERS,
  });
}
